import { z } from 'zod';
/**
 * A bounded BCP 47 language tag for user-facing generated content.
 *
 * The UI may expose only a subset today, while this transport contract stays open to new
 * languages without a schema migration for every locale that product adds.
 */
export const responseLocaleSchema = z
    .string()
    .trim()
    .min(2)
    .max(64)
    .regex(/^[A-Za-z]{2,8}(?:-[A-Za-z0-9]{1,8})*$/u);
/**
 * Builds the single product-wide instruction for user-facing generated language.
 * `und` means that an older client did not declare a locale; it is never a display language.
 */
export function responseLanguageInstruction(responseLocale) {
    const parsed = responseLocaleSchema.safeParse(responseLocale);
    if (!parsed.success)
        return null;
    if (parsed.data === 'und') {
        return ('\n\nRequired response language:' +
            '\n- The client did not declare a locale. Match the language of the latest user message. If it contains no natural language, use the established conversation language; once canonical website evidence provides a valid BCP 47 source language, use that language for newly generated user-facing replies and draft fields.' +
            '\n- Preserve brand names, URLs, provider identifiers, quoted evidence, and technical enum values exactly; do not translate stored historical content.');
    }
    return ('\n\nRequired response language:' +
        `\n- Write user-facing replies and newly generated human-readable draft fields in the language identified by BCP 47 tag ${JSON.stringify(parsed.data)}.` +
        '\n- Historical artifacts and evidence remain source material, not a language override. Translate or paraphrase their prose when deriving a new human-readable field in the response language.' +
        '\n- Preserve brand names, URLs, provider identifiers, verbatim quoted evidence, and technical enum values exactly; never mutate the stored source records.');
}
//# sourceMappingURL=locale.js.map